<template>
    <tr @click="openMessage(message.id)"
        :style="(!message.read && type !== 'drafts' && type !== 'trash' ? 'border-left: solid 8px orange' : '')"
        class="cursor-pointer hover:bg-indigo-50">

        <td class="w-full max-w-0 py-2 pl-4 pr-3 text-sm font-medium text-gray-900 lg:w-auto lg:max-w-none sm:pl-6">
            <span> {{ senderOrRecipientFull }} </span>
            <dl class="font-normal lg:hidden">
                <dd class="mt-1 truncate text-gray-700">{{ subject }}</dd>
                <dd v-if="type === 'sent' || type === 'trash'" class="mt-1 truncate text-gray-700">
                    <MessagesTableRowStatusBadge v-if="message.direction === 2" :message="message"/>
                </dd>
                <dd v-html="dateTime" class="mt-1 truncate text-gray-500 sm:hidden"></dd>
            </dl>
        </td>
        <td class="hidden px-3 py-2 text-sm text-gray-500 lg:table-cell">{{ subject }}</td>
        <td v-if="type === 'sent' || type === 'trash'" class="hidden px-3 py-2 text-sm text-gray-500 lg:table-cell">
            <MessagesTableRowStatusBadge v-if="message.direction === 2" :message="message"/>
        </td>
        <td v-html="dateTime" class="hidden px-3 py-2 text-sm text-gray-500 sm:table-cell text-right"></td>



        <td class="absolute py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
            <MessagesTableRowOptions @refreshMessages="refreshMessages" :type="type" :message="message"/>
        </td>

    </tr>
</template>

<script>
import MessagesTableRowOptions from "./MessagesTableRowOptions";
import MessagesTableRowStatusBadge from "./MessagesTableRowStatusBadge";

export default {
    name: "MessagesTableRow",
    components: {MessagesTableRowStatusBadge, MessagesTableRowOptions},
    props: ['type', 'message'],
    emits: ['refreshMessages'],
    data(){
        return {

        }
    },
    methods: {
        openMessage(){
            if(this.showMessageOptions == null)
                if(this.$props.type === 'drafts')
                    this.$inertia.visit(route('compose', this.$props.message.id));
                else
                    this.$inertia.visit(route('view', this.$props.message.id));
            else
                this.showMessageOptions = null;
        },
        refreshMessages(manual = 0){
            this.$emit('refreshMessages', manual);
        }

    },
    computed: {
        dateTime(){
            let time = null;
            if(this.$props.type === 'drafts')
                time = this.$props.message.updated_at;
            else
                time = this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDeliveryTime;

            return (new Date(time).toLocaleDateString())
                    .replaceAll(' ', '&nbsp;')
                +'<br class="sm:block hidden"> '
                +(new Date(time).toLocaleTimeString())
                    .replaceAll(' ', '&nbsp;')
        },
        subject(){
            if(this.$props.type === 'drafts') return this.$props.message.subject ? this.$props.message.subject : '[bez předmětu]';
            return this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation;
        },
        sender(){
            return this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSender;
        },
        senderId(){
            return this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDm.dbIDSender;
        },
        recipient(){
            if(this.$props.type === 'drafts') return this.$props.message.recipient_name ? (this.$props.message.recipient_name) : '[bez adresáta]';
            return this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipient;
        },
        recipientId(){
            if(this.$props.type === 'drafts') return this.$props.message.recipient_id ? this.$props.message.recipient_id : null;
            return this.$props.message.MessageDownloadResponse.dmReturnedMessage.dmDm.dbIDRecipient;
        },
        senderOrRecipientFull(){
            if(this.$props.type === 'drafts') return this.recipient + (this.recipientId !== null ? ' (' + this.recipientId + ')' : '');
            if(this.$props.type === 'inbox') return this.sender + ' (' + this.senderId + ')'
            if(this.$props.type === 'sent') return this.recipient + ' (' + this.recipientId + ')'
            if(this.$props.type === 'trash'){
                if(this.$props.message.direction === 1) return this.sender + ' (' + this.senderId + ')';
                if(this.$props.message.direction === 2) return this.recipient + ' (' + this.recipientId + ')';
            }
        },
    }
}
</script>

<style scoped>

</style>
